export enum EModules {
  TOPCON_IDENTITY = "TOPCON_IDENTITY",
  TOPCON_TECH = "TOPCON_TECH",
  TOPCON_CUSTOMER = "TOPCON_CUSTOMER",
  TOPCON_DISPATCH = "TOPCON_DISPATCH",
  TOPCON_FLEET = "TOPCON_FLEET",
  TOPCON_BATCH = "TOPCON_BATCH",
  TOPCON_BI = "TOPCON_BI",
}